export enum ProjectStatusEnum {
    Unknown = 0,
    Active = 1,
    Finished = 2,
    NotInitiated = 3
}

